<template>
  <div class="o-filters__modes o-filters__modes--flex-wrap">
    <div v-for="tab in tabs" :key="tab.id" :class="getClass(tab.id)" @click="selectTab(tab.id)">
      <div class="icon o-filters__modes-item-icon">
        <pin v-if="tab.icon === 'pin'" :color="getIconColor(tab.id)" />
        <list v-if="tab.icon === 'list'" :color="getIconColor(tab.id)" />
      </div>
      {{ tab.label }}
    </div>
  </div>
</template>

<script>
import pin from '@/assets/pin'
import list from '@/assets/list'

export default {
  components: {
    pin,
    list
  },
  props: {
    value: {
      type: Number,
      required: true
    },
    tabs: {
      type: Array,
      required: true
    }
  },
  computed: {
    selectedTabId: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    getClass: function(tabId) {
      let classNames = 'o-filters__modes-item'

      if (tabId === this.selectedTabId) {
        classNames += ' o-filters__modes-item--active'
      }

      if (tabId > 0 && tabId < this.tabs.length - 1) {
        classNames += ' o-filters__modes-item--no-radius'
      }

      return classNames
    },
    getIconColor: function(tabId) {
      if (tabId === this.selectedTabId) {
        return '#fff'
      } else {
        return '#7667A7'
      }
    },
    selectTab(tabId) {
      this.selectedTabId = tabId
    }
  }
}
</script>